import * as _ from '@/styles/main.sass'
import { setI18nLanguage } from '@/i18n'
import { createVue } from '@/app'
import type { SessionMap } from '@/models/api-generated'
import { initHttp } from '@/services/http'
import { initCountedTextareas } from '@/scripts/textarea-counter'
import { legacyReady } from '@/scripts/legacy'
import toastStore from '@/stores/toast'

declare global {
	let sessionMap: SessionMap
}

document.addEventListener('DOMContentLoaded', () => {
	setI18nLanguage(sessionMap.language)
	createVue().mount('app')

	initHttp()

	legacyReady(toastStore())
	initCountedTextareas()
})
